import { render, staticRenderFns } from "./ChatToggle.vue?vue&type=template&id=7ffe45ce&scoped=true"
import script from "./ChatToggle.vue?vue&type=script&lang=js"
export * from "./ChatToggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffe45ce",
  null
  
)

export default component.exports